// components/ClockWeatherWidget.jsx
import { useEffect, useState } from "react";

export default function ClockWeatherWidget() {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const formatTime = time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  const formatDate = time.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });

  return (
    <div className="flex items-center gap-3 bg-white/80 backdrop-blur-sm shadow px-4 py-2 rounded-xl border border-gray-200 text-sm font-medium text-gray-700">
      <div>
        <span className="text-indigo-600">{formatTime}</span>
        <span className="mx-2 text-gray-400">•</span>
        <span>{formatDate}</span>
      </div>
      <div className="ml-auto text-blue-600 flex items-center gap-1">
        <span>🌤️</span>
        <span>28°C</span>
      </div>
    </div>
  );
}
